import React, { useRef } from 'react';
import usePullToRefresh from '../utils/pullToRefresh';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from '../utils/icons';

interface PullToRefreshWrapperProps {
  onRefresh: () => Promise<void>;
  children: React.ReactNode;
  threshold?: number;
  className?: string;
}

const PullToRefreshWrapper: React.FC<PullToRefreshWrapperProps> = ({
  onRefresh,
  children,
  threshold = 100,
  className = 'content',
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const {
    isRefreshing,
    spinnerSize,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
  } = usePullToRefresh(onRefresh, threshold, scrollContainerRef);

  return (
    <div
      className={className}
      ref={scrollContainerRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {isRefreshing && (
        <div
          className="loading-indicator"
          style={{ height: `${spinnerSize}px` }}
        >
          <FontAwesomeIcon icon={icons.spinner} spin />
        </div>
      )}
      {children}
    </div>
  );
};

export default PullToRefreshWrapper;